var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIconInputs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8422 2.76171C14.8422 2.34731 14.6776 1.94988 14.3846 1.65685C14.0916 1.36383 13.6941 1.19921 13.2797 1.19921C12.8653 1.19921 12.4679 1.36383 12.1749 1.65685L8.02063 5.81111L3.86638 1.65685C3.57335 1.36383 3.17592 1.19921 2.76152 1.19921C2.34712 1.19921 1.94969 1.36383 1.65667 1.65685C1.36364 1.94988 1.19902 2.34731 1.19902 2.76171C1.19902 3.17611 1.36364 3.57354 1.65667 3.86656L5.81092 8.02082L1.65667 12.1751C1.36364 12.4681 1.19902 12.8655 1.19902 13.2799C1.19902 13.6943 1.36364 14.0918 1.65667 14.3848C1.94969 14.6778 2.34712 14.8424 2.76152 14.8424C3.17593 14.8424 3.57335 14.6778 3.86638 14.3848L8.02063 10.2305L12.1749 14.3848C12.4679 14.6778 12.8653 14.8424 13.2797 14.8424C13.6941 14.8424 14.0916 14.6778 14.3846 14.3848C14.6776 14.0918 14.8422 13.6943 14.8422 13.2799C14.8422 12.8655 14.6776 12.4681 14.3846 12.1751L10.2303 8.02082L14.3846 3.86656C14.6776 3.57354 14.8422 3.17611 14.8422 2.76171Z",
    fill: "#383838",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconInputs);
export default __webpack_public_path__ + "static/media/close-icon-inputs.957a87e58f0af148e130162132b12e6a.svg";
export { ForwardRef as ReactComponent };